
  import { Component, Prop, Vue } from 'vue-property-decorator';
  import { OrderModel } from '@/models';

  @Component
  export default class Details extends Vue {
    @Prop() readonly order!: OrderModel;
  }
